/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Field_TargetInputs */

const en_us2_clubs_field_target = /** @type {(inputs: Clubs_Field_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goal per person`)
};

const pt_br2_clubs_field_target = /** @type {(inputs: Clubs_Field_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta por pessoa`)
};

const es_419_clubs_field_target = /** @type {(inputs: Clubs_Field_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta por persona`)
};

const pt_pt2_clubs_field_target = /** @type {(inputs: Clubs_Field_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objetivo por pessoa`)
};

const fr_fr2_clubs_field_target = /** @type {(inputs: Clubs_Field_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objectif par personne`)
};

const de_de2_clubs_field_target = /** @type {(inputs: Clubs_Field_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziel pro Person`)
};

const it_it2_clubs_field_target = /** @type {(inputs: Clubs_Field_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obiettivo a persona`)
};

/**
* | output |
* | --- |
* | "Goal per person" |
*
* @param {Clubs_Field_TargetInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_field_target = /** @type {((inputs?: Clubs_Field_TargetInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Field_TargetInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_field_target(inputs)
	if (locale === "es-419") return es_419_clubs_field_target(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_field_target(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_field_target(inputs)
	if (locale === "de-DE") return de_de2_clubs_field_target(inputs)
	if (locale === "it-IT") return it_it2_clubs_field_target(inputs)
	return en_us2_clubs_field_target(inputs)
});
export { clubs_field_target as "clubs.field_target" }